// extracted by mini-css-extract-plugin
module.exports = {"container":"picture-only_container__RAPzO"};